import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["customerSelector", "email", "phone"]

  connect() {
    this.fillInCustomerDetails()
  }

  fillInCustomerDetails() {
    const selectedOption = this.customerSelectorTarget.selectedOptions[0]
    if (selectedOption && this.emailTarget && this.phoneTarget) {
      this.emailTarget.value = selectedOption.dataset.email || ''
      this.phoneTarget.value = selectedOption.dataset.phone || ''
    }
  }
}
